
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/index.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/contribute/index.md?type=demo')
};